import styled from '@emotion/styled';

import { COLORS3 as COLORS, FONT, MEDIA_QUERY, SPACING } from '../../styles/emotion';
import { LinkV2 } from '../LinkV2';

export const TopicTilesWrapper = styled.div`
  border-bottom: var(--border-grid, 1px solid ${COLORS.BLACK_030});
  display: flex;
  flex-direction: column;
  max-width: 1920px;
  padding: ${SPACING.S32} ${SPACING.S24};

  ${MEDIA_QUERY.TABLET} {
    padding: 56px;
  }

  ${MEDIA_QUERY.DESKTOP} {
    padding: 56px;
  }

  ${MEDIA_QUERY.DESKTOP_MASSIVE} {
    padding: 64px;
  }
`;

export const HedWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledH3 = styled.h3`
  color: var(--text-primary);
  font-size: ${FONT.FONT_SIZE_REGULAR};
  letter-spacing: -1.2px;
  line-height: 130%;

  ${MEDIA_QUERY.TABLET} {
    font-size: ${FONT.FONT_SIZE_LARGER};
    line-height: 100%;
  }

  ${MEDIA_QUERY.DESKTOP} {
    font-size: ${FONT.FONT_SIZE_LARGER};
    letter-spacing: -0.04em;
    line-height: 125%;
  }
`;

export const NoWrapLink = styled(LinkV2)`
  white-space: nowrap;
`;

export const TopicsList = styled.ul`
  display: grid;
  grid-column-gap: ${SPACING.XS};
  grid-row-gap: ${SPACING.S16};
  grid-template-columns: repeat(2, 1fr);
  margin-top: 28px;

  ${MEDIA_QUERY.TABLET} {
    grid-column-gap: ${SPACING.S16};
    grid-template-columns: repeat(3, 1fr);
    margin-top: 48px;
  }

  ${MEDIA_QUERY.DESKTOP} {
    grid-column-gap: ${SPACING.S16};
    grid-template-columns: repeat(6, 1fr);
    margin-top: ${SPACING.S32};
  }

  ${MEDIA_QUERY.DESKTOP_XL} {
    margin-top: 48px;
  }
`;

export const TopicLink = styled.a<{ hasIcon?: boolean }>`
  align-items: center;
  background-color: var(--background-container, ${COLORS.BLACK_005});
  border-radius: 16px;
  column-gap: ${SPACING.XS};
  display: grid;
  font-size: ${FONT.FONT_SIZE_SMALLER};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  grid-template-columns: ${({ hasIcon }) => (hasIcon ? '24px 1fr' : null)};
  height: 64px;
  line-height: ${FONT.FONT_SIZE_REGULAR};
  padding: 0 ${SPACING.S16};
  text-decoration: none;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
    transform: scale(1.02);
  }
`;
